import { render, staticRenderFns } from "./CadastreEntity.vue?vue&type=template&id=65a8ca03&scoped=true"
import script from "./CadastreEntity.vue?vue&type=script&lang=js"
export * from "./CadastreEntity.vue?vue&type=script&lang=js"
import style0 from "./CadastreEntity.vue?vue&type=style&index=0&id=65a8ca03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a8ca03",
  null
  
)

export default component.exports